import React from 'react';
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { theme } from './styles/theme';
import NavBar from './components/ui/nav/NavBar';
import FooterSection from './components/sections/shared/footer/FooterSection';
import HomePage from './components/pages/HomePage';
import ServicesPage from './components/pages/ServicesPage';
import WorkPage from './components/pages/WorkPage';
import AboutPage from './components/pages/AboutPage';
import ContactPage from './components/pages/ContactPage';
import ImprintPage from './components/pages/ImprintPage';
import PrivacyPage from './components/pages/PrivacyPage';
import ScrollToTop from './components/ui/ScrollToTop';

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
                <ScrollToTop />
                <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                    <NavBar />
                    <Box component="main" sx={{ flex: 1 }}>
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/services" element={<ServicesPage />} />
                            <Route path="/work" element={<WorkPage />} />
                            <Route path="/about" element={<AboutPage />} />
                            <Route path="/contact" element={<ContactPage />} />
                            <Route path="/imprint" element={<ImprintPage />} />
                            <Route path="/privacy" element={<PrivacyPage />} />
                        </Routes>
                    </Box>
                    <FooterSection />
                </Box>
            </Router>
        </ThemeProvider>
    );
}

export default App;
